import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-ticket-sub-type',
  templateUrl: './modify-ticket-sub-type.component.html',
  styleUrls: ['./modify-ticket-sub-type.component.css']
})
export class ModifyTicketSubTypeComponent implements OnInit {
  ticketsubtypeId: any = "";

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  editForm: any | FormGroup
  modelSubtitle = false
  sub_ticket:any = []
  cid:any
  
  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllSubTickets()

    this.editForm = this.fb.group({
      name: [''],
      remarks: [''],
      version: [''],
    });
  }

  updateTicketSubType(){

    let body = {
      "version": Number(this.editForm.get('version').value),
      "isActive": true,
      "description": "string",
      "id": this.ticketsubtypeId,
      "typeId": 0,
      "name": String(this.editForm.get('name').value),
      "remarks": String(this.editForm.get('remarks').value),
      "displayOrder": "string",
      "cid": this.cid
    }
    console.log(body)
    this.generic_service.updateTicketSubType(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllSubTickets()
        this.toastr.success("Successfully Updated");
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.errors[0].description);

      }
    )
  }
  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllSubTickets(){
    this.generic_service.getAllSubTickets().subscribe(
      (response:any)=>{
        this.sub_ticket = response.response;
        console.log(response)
      }
    )
  }

  getTicketSubTypeById(id:any){
    this.ticketsubtypeId = id
    this.generic_service.getTicketSubTypeById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.editForm.patchValue({
          name: response.response.name,
          version: response.response.version,
          remarks: response.response.remarks,
        })
        console.log(this.editForm.value)
      },
      (error)=>{
        console.log(error)
      }
    )
  }

}
